import showMessage from "../common/showMessage";
const handleRequestFail = (reservationForm) => () => {
    showMessage.error(reservationForm, "クラス予定の取得中にエラーが発生しました。<br>再度お試しください。");
};
export default handleRequestFail;
